import Countly from "countly-sdk-web";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (!config.public.countlyAppKey || !config.public.countlyUrl) {
    return {
      provide: {
        countly: null,
      },
    };
  }

  Countly.init({
    app_key: config.public.countlyAppKey,
    url: config.public.countlyUrl,
    debug: false,
  });

  Countly.track_sessions();

  return {
    provide: {
      countly: Countly,
    },
  };
});
